<template>
    <div class="form-dynamic-wrapper mb-2" style="max-width:100% !important">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="spesifikasi.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group>
                    <label>Short Name</label>
                    <b-form-input v-model="spesifikasi.shortName" name="spesifikasiShortName" placeholder="Short Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>        
            <b-col md="4">
                <b-form-group>
                    <label>
                        Persen
                    </label>
                    <b-input-group append="%">
                        <b-form-input v-model="spesifikasi.reduction" :id="`persenDesc-${spesifikasi.index}`" name="spesifikasireduction" step="0.01" type="number" @blur="roundPersen" :disabled="spesifikasi.detailInfo == 'nominal'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-popover :target="`persenDesc-${spesifikasi.index}`" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-col>
        </b-row>      
        
        <div class="form-dynamic-deleteWrapper">
            <!-- <b-button variant="dynamicDeleteBtn" name="deleteSpesifikasi" @click="$emit('remove', spesifikasi.index)"><i class="fa fa-times"></i></b-button> -->
            <b-button variant="dynamicDeleteBtn mt-2" name="nonAktifSpesifikasi" :disabled="spesifikasi.isNewSpek == true" @click="$emit('nonAktif', spesifikasi)"><i class="fa fa-minus"></i></b-button>
        </div>

    </div>
    
</template>

<script>
export default {
   
    name: "spesifikasi",
  
    props: {
        spesifikasi: { type: Object, required: true },
        length: { type: Number, required: true },
    },
    
    data() {
        return {
            confirmDelId:null,
            confirmDelIndex:null,
        }
    },
    
    
    methods: {
        roundPersen() {
            var x = Number(this.spesifikasi.reduction).toFixed(2);
            this.spesifikasi.reduction = x;
        },
    },

    watch: {

        "spesifikasi.reduction": function(newValue) {
            if (newValue > 100) {
                this.spesifikasi.reduction = 0
                this.$helper.toastErr(this,"nominal persen tidak boleh diatas 100")
            }
        },
    },   
  
}
</script>
